export const rotateSeats = (element) =>{
    var tables = document.querySelectorAll(".table-container")

    tables.forEach(table => {
        var seats = table.querySelectorAll(".asiento-container")
        var grades  = 360 / seats.length

        seats.forEach((seat,index) => {
            seat.style.transform = `rotateZ(${grades*index}deg)`
        })
    })
}